import { capitalize } from 'lodash';
import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { SelectField, NumberField } from 'react-admin';

import Label from '../../../customFields/Label';
import TransactionTypeConfigurationField from '../../../customFields/TransactionTypeConfigurationField';
import anomalyDeviationDirections, { anomalyDeviationDirectionChoices } from '../../../constants/anomalyDeviationDirections';
import { timePeriodChoices } from '../../../constants/timePeriods';
import { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';

const SimpleAnomalyDetection = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <Grid size={12}>
        <Label
          variant="label"
          title="Transaction types configuration"
        />
      </Grid>
      <Grid size={12}>
        <TransactionTypeConfigurationField source="ruleParameters.transactionTypeConfiguration" />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Transaction monitoring mode"
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={transactionMonitoringModesChoices}
          source="ruleParameters.transactionMonitoringMode"
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="The deviation percentage and direction which this rule should detect."
          info={(
            <Box>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Lower.
                </Box>
                {' '}
                Detect if the deviation is lower than the historical average.
              </Typography>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Higher.
                </Box>
                {' '}
                Detect if the deviation is higher than the historical average.
              </Typography>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Both.
                </Box>
                {' '}
                Detect both lower and higher deviation from the historical average.
              </Typography>
            </Box>
          )}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography>
          <NumberField source="ruleParameters.threshold" />
          %
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={anomalyDeviationDirectionChoices}
          emptyText={capitalize(anomalyDeviationDirections.BOTH)}
          source="ruleParameters.deviationDirection"
          label="Deviation Direction"
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="The minimum number of transactions that must have been made by the entity for rule to apply"
        />
      </Grid>
      <Grid size={12}>
        <NumberField source="ruleParameters.minimumNumberOfObservations" />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="The minimum time that must have passed from the first transaction made by the entity for the rule to apply."
          info="The period will determine if a entity have been in the system long enough to be used."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberField source="ruleParameters.minimumUsageTime.amount" />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={timePeriodChoices}
          source="ruleParameters.minimumUsageTime.unit"
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Determines the total period over which smaller period sums will be computed to form an average."
          info="The period that will be used to determine the start of the history to include."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberField source="ruleParameters.periodToConsider.amount" />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={timePeriodChoices}
          source="ruleParameters.periodToConsider.unit"
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="The smaller period used to compute sums."
          info="The period that will be used to get windows from the history."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberField source="ruleParameters.windowPeriod.amount" />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={timePeriodChoices}
          source="ruleParameters.windowPeriod.unit"
        />
      </Grid>
    </Grid>
  </Grid>

);

export default SimpleAnomalyDetection;
